module.exports = __webpack_public_path__ + "img/medical_medicine_external.bee70908.jpg";